import { useEffect, useState } from 'react';
import { authService } from '../components/shared/hooks/AuthService';

/**
 * Public community metrics from GET /auth/user-count (count = registered, active = recent).
 */
export function useCommunityUserStats() {
  const [stats, setStats] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authService.getUserCount();
        const payload = res?.data?.data ?? res?.data;
        if (cancelled) return;
        if (payload && (payload.count != null || payload.active != null)) {
          setStats({
            count: Number(payload.count ?? 0),
            active: Number(payload.active ?? 0),
          });
          setStatus('ready');
        } else {
          setStatus('empty');
        }
      } catch {
        if (!cancelled) setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { stats, status, loading: status === 'loading' };
}

export function formatCommunityStatLine(stats) {
  if (!stats) return null;
  const total = Number(stats.count ?? 0);
  const active = Number(stats.active ?? 0);
  const totalLabel = total.toLocaleString();
  if (active > 0) {
    return `${active.toLocaleString()} learners active now · ${totalLabel} joined QnaRead`;
  }
  return `${totalLabel} learners on QnaRead`;
}
